import {createStateMaker} from '@shared/helpers/object'

import {APIStatus} from '@web/core/constants'

import {OrderSheetCouponState} from '../interfaces'

export const getSelectedCoupon = (): OrderSheetCouponState['selected'] => ({
    deliveryCoupon: {},
    immediateCoupon: {},
    duplicateCoupon: {},
    productCoupon: {},
    storeCoupon: {},
    multiPurchaseCoupon: [],
    subscriptionCoupon: [],
})

export const getInitialState = (): OrderSheetCouponState => ({
    deliveryFee: {
        couponsByDeliveryGroupKey: {},
        usableCount: 0,
        validCount: 0,
        isOptimized: false,
    },
    product: {
        immediateCouponsByOrderSheetItemId: {},
        duplicateCouponsByOrderSheetItemId: {},
        couponsByOrderSheetItemId: {},
        couponsByMerchantNo: {},
        multiPurchaseDiscounts: {},
        usableCount: 0,
        validCount: 0,
    },
    apiStatus: APIStatus.IDLE,
    beforeApplyCoupon: getSelectedCoupon(),
    beforeApplyTemporaryCoupon: getSelectedCoupon(),
    selected: getSelectedCoupon(),
    optimizedCoupon: getSelectedCoupon(),
    discountOptimization: false,
    discount: {
        productItem: {},
    },
    simulateDiscount: {
        productItem: {},
    },
    applyType: 'direct',
    couponPageType: 'default',
    subscriptionDiscountPolicesByOrderSheetItemId: {},
    couponStatus: 'default',
})

export const makeMock = createStateMaker<OrderSheetCouponState>(getInitialState)
